import { getRehabResult, setTab } from '@Actions';
import { InspectionStandard } from '@Types';
import { AssetType } from '@innovyze/lib-am-common';
import React from 'react';
import { useDispatch } from 'react-redux';
import RehabResultTable from './RehabResultTable';

export interface InspDetailActions {
	onInspectionDetailClicked?: (
		videoUrl: string,
		InspectionID: string,
		standard: InspectionStandard,
	) => void;
}

export interface AssetDetailActions {
	onAssetDetailClicked?: (assetId: string, assetType: string) => void;
}

export interface RehabResultProps {
	readonly treeId: string;
	readonly lastRunCompleted?: string;
	readonly assetAction?: AssetDetailActions;
	readonly assetType: string;
	readonly loadResults: boolean;
	onResultsLoaded: (loadResults: boolean) => void;
}

export default function RehabResult({
	treeId,
	lastRunCompleted,
	assetAction,
	assetType,
	loadResults,
	onResultsLoaded,
}: RehabResultProps) {
	// hooks
	const dispatch = useDispatch();

	// effects
	React.useEffect(() => {
		if (loadResults) {
			dispatch(getRehabResult());
			onResultsLoaded(false);
		}
	}, [treeId, loadResults]);
	React.useEffect(() => {
		dispatch(setTab('Results'));
	}, []);

	return (
		<>
			<RehabResultTable
				assetType={assetType as AssetType}
				treeId={treeId}
				lastRunCompleted={lastRunCompleted}
				assetAction={assetAction}
			/>
		</>
	);
}
